import { apiRequest } from "../client";
import { GetObjectsResponse, VitroInfoResult } from "./types/model";

async function get<T>(url: string): Promise<T> {
    var response = await apiRequest(`${url}`, {
        method: 'GET'
    });

    return await response.json() as T;
}

async function downloadFile(url: string, filename?: string): Promise<void> {
    const response = await apiRequest(url, {
        method: 'GET'
    });

    if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename || 'file';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
}

export const api = {
    GetObjects: (livingComplexId: number, name?: string) => {
        const params = new URLSearchParams();
        params.append("livingComplexId", livingComplexId.toString());
        if (name) {
            params.append("name", name);
        }
        return get<GetObjectsResponse>(`/objects?${params.toString()}`)
    },
    GetObjectInfo: (id: string) => get<VitroInfoResult>(`/object/${id}/info`),
    GetFile: (id: string, filename?: string) => downloadFile(`/object/file/${id}`, filename)
}